import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import WarrantyDataContainer from "features/document/edit/financials/warranty/components/WarrantyDataContainer";

export const FolderWarrantiesListComponent = ({ folderOffers, openFolderOffer }) => {
  return (
    folderOffers.length > 0 &&
    folderOffers.map(folderOffer => (
      <WarrantyDataContainer
        key={folderOffer.offerId}
        documentId={folderOffer.offerId}
        siteId={folderOffer.offerSiteId}
        folderOffer={folderOffer}
        openFolderOffer={openFolderOffer}
      />
    ))
  );
};

FolderWarrantiesListComponent.propTypes = {
  folderOffers: PropTypes.array.isRequired,
  openFolderOffer: PropTypes.func.isRequired
};

export default withTranslation()(FolderWarrantiesListComponent);
